module.exports = __webpack_public_path__ + "img/default_gongzuofeng.ba1fe7e4.png";